import cloneDeep from 'lodash/cloneDeep';

import { SelectOption } from 'src/components/Select/Select.types';

export const getSelectedPage = (offset?: number, limit?: number) => {
  return offset !== undefined && limit !== undefined ? Math.floor(1 + offset / limit) : 1;
};

export const getTotalPages = ({ totalItems, itemsPerPage }: { totalItems: number; itemsPerPage: number }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  return Math.max(1, totalPages);
};

export const adjustPageAfterDelete = ({
  deletedItems,
  currentTotal,
  limit,
  offset,
}: {
  deletedItems: any;
  currentTotal: number;
  limit: number;
  offset: number;
}): { changePage: boolean; newPage: number; newOffset: number } => {
  const currentPage = getSelectedPage(offset, limit);
  const countToDelete = Array.isArray(deletedItems) ? deletedItems.length : 1;
  const expectedTotalItems = currentTotal - countToDelete;
  const totalPages = getTotalPages({ totalItems: expectedTotalItems, itemsPerPage: limit });
  const newPage = Math.min(currentPage, totalPages);
  const newOffset = getOffset({ itemsPerPage: limit, page: newPage });
  const changePage = currentPage !== newPage;
  // both newPage and newOffset are different views of the same information.
  return { changePage, newPage, newOffset };
};

export const getOffset = ({ itemsPerPage, page }: { itemsPerPage: number; page: number }) => itemsPerPage * (page - 1);

export const getPaginatedItems = (items: any[] | undefined, page: number, itemsPerPage: number) => {
  if (!items) {
    return undefined;
  }
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return cloneDeep(items)?.slice(startIndex, endIndex);
};

export const getItemsPerPageOptions = ({ itemsPerPageOptions }: { itemsPerPageOptions: number[] }): SelectOption[] => {
  return itemsPerPageOptions.map((number) => ({
    label: number,
    value: number,
  }));
};

export const getCurrentPageOptions = ({
  totalItems,
  itemsPerPage,
}: {
  totalItems: number;
  itemsPerPage: number;
}): SelectOption[] => {
  const totalPages = getTotalPages({ totalItems, itemsPerPage });
  const pageOptions: SelectOption[] = [];

  for (let page = 1; page <= Math.min(99, totalPages); page += 1) {
    pageOptions.push({
      label: page,
      value: page,
    });
  }

  return pageOptions;
};
